var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.594,
    height: 27.594,
    viewBox: "0 0 27.594 27.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-137.203 -172.203)",
    opacity: 0.733
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    transform: "translate(137.203 190.599)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.599,
    cy: 4.599,
    r: 4.599,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.599,
    cy: 4.599,
    r: 4.099,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "translate(155.599 190.599)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.599,
    cy: 4.599,
    r: 4.599,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.599,
    cy: 4.599,
    r: 4.099,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(155.599 172.203)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.599,
    cy: 4.599,
    r: 4.599,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.599,
    cy: 4.599,
    r: 4.099,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(137.203 172.203)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.599,
    cy: 4.599,
    r: 4.599,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.599,
    cy: 4.599,
    r: 4.099,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.b9a9e5172cbc75e9c2e16b547e5c31a8.svg";
export { ForwardRef as ReactComponent };